module.exports = __webpack_public_path__ + "static/media/1.d31ee99d.jpg";